<template>
  <div>
    <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item label="姓名">
          <a-input v-model="dataForm.name" placeholder="请输入姓名"> </a-input>
        </a-form-item>
        <a-form-item label="分包单位">
          <a-input
            v-model="dataForm.company_name"
            placeholder="分包单位模糊查询"
            :disabled="dataForm.company_null == 2"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="过滤无分包单位人员">
          <a-radio-group
            name="radioGroup"
            v-model="dataForm.company_null"
            @change="changeCompanyNull"
          >
            <a-radio :value="1"> 否 </a-radio>
            <a-radio :value="2"> 是 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            @click="
              (dataForm.name = ''),
                (dataForm.company_name = ''),
                (dataForm.company_null = 1)
            "
          >
            重置
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card style="border: none; border-radius: 12px" title="人员列表">
      <div slot="extra">
        <a-button
          icon="redo"
          @click="query"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          刷新数据
        </a-button>
        <a-button
          icon="edit"
          @click="batchUpload"
          style="background: #fff9f0; border: none; color: #ef9f22"
          v-permission="['person:person:add']"
        >
          一键导入
        </a-button>
        <a-button
          @click="addOrUpdateHandle_()"
          icon="plus"
          style="background: #fff9f0; border: none; color: #ef9f22"
          v-permission="['person:person:add']"
        >
          新建人员
        </a-button>
        <a-button
          @click="resetCompany()"
          icon="login"
          type="primary"
          v-permission="['person:person:resetCompany']"
          :disabled="dataListSelections.length == 0"
        >
          批量分配分包单位
        </a-button>
      </div>
      <a-table
        filterMultiple
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        :scroll="{ x: 1500 }"
        rowKey="id"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onSelect: onSelect,
          onChange: onSelectChange,
          onSelectAll: onSelectAll,
        }"
      >
        <span slot="company_name" slot-scope="text">
          <span v-if="text">{{ text }}</span>
          <a-tag color="red" v-else> 未分配分包单位 </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle_(record.id, record.project_id, 1)"
              v-permission="['person:person:page']"
              >查看
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="addOrUpdateHandle_(record.id, record.project_id)"
              v-permission="['person:person:edit']"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="deleteHandle(record.id)"
              v-permission="['person:person:delete']"
              >删除</a-button
            >
            <a-button
              size="small"
              type="link"
              :style="{ color: record.is_exit == 1 ? '#F60' : '' }"
              @click="exit(record.id, record.is_exit)"
              v-permission="['person:person:exit']"
              >{{ record.is_exit == 0 ? "退场" : "进场" }}</a-button
            >
          </a-space>
        </span>
        <span slot="finger" slot-scope="text, record">
          <span v-if="text" style="cursor: pointer">已录</span>
          <a-button
            v-else
            type="link"
            @click="addOrUpdateHandle_(record.id, record.project_id)"
            >去录入>></a-button
          >
        </span>
        <span slot="age" slot-scope="text, record">
          <a-badge
            :status="
              record.age_status == 1
                ? 'success'
                : record.age_status == 2
                ? 'warning'
                : 'error'
            "
          />{{ record.age }}
        </span>
      </a-table>
      <div style="margin-top: 20px; float: left">
        <a-button
          @click="exportHandle()"
          icon="download"
          style="background: #edf5ff; border: none; color: #0073ff"
        >
          导出
        </a-button>
      </div>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :pageSizeOptions="pageSizeOptions"
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
    <batchUploadPerson
      ref="batchUploadPerson"
      @ok="getDataList"
    ></batchUploadPerson>
    <ResetCompany ref="resetCompany" @confirm="confirmCompany"></ResetCompany>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./components/companyaddorupdate";
import batchUploadPerson from "./components/batchUploadPerson";
import { personFile } from "@/utils/exportFile";
import { exitPerson, resetCompanyId } from "@/request/person";
import ResetCompany from "./components/resetCompany";
import moment from "moment";
export default {
  mixins: [viewModule],
  components: { addOrUpdate, batchUploadPerson, ResetCompany },
  data() {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 80,
          align: "center",
          customRender: (text, record, index) => {
            return (this.page - 1) * this.limit + index + 1;
          },
        },
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          align: "center",
          fixed: "left",
          width: 100,
        },
        {
          title: "分包单位",
          dataIndex: "company_name",
          key: "company_name",
          align: "center",
          fixed: "left",
          width: 150,
          scopedSlots: { customRender: "company_name" },
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          key: "phone",
          align: "center",
          width: 150,
        },

        {
          title: "性别",
          align: "center",
          key: "gender",
          dataIndex: "gender",
          width: 80,
        },
        {
          title: "年龄",
          align: "center",
          key: "age",
          dataIndex: "age",
          width: 80,
          scopedSlots: { customRender: "age" },
        },
        {
          title: "工种",
          align: "center",
          key: "work_name",
          dataIndex: "work_name",
          width: 100,
          // customRender: (text) => `${text}万元`,
        },
        {
          title: "职务",
          align: "center",
          key: "duties",
          dataIndex: "duties",
          width: 120,
        },
        {
          title: "工号",
          align: "center",
          key: "job_no",
          dataIndex: "job_no",
          width: 100,
        },
        // {
        //   title: "人脸录入",
        //   align: "center",
        //   key: "contacts",
        //   dataIndex: "contacts",
        //   width: 120,
        // },
        {
          title: "指纹",
          align: "center",
          key: "finger",
          dataIndex: "finger",
          width: 200,
          scopedSlots: { customRender: "finger" },
        },
        {
          title: "住址",
          align: "center",
          key: "address",
          dataIndex: "address",
          width: 200,
        },
        {
          title: "入场时间",
          align: "center",
          key: "create_time",
          dataIndex: "create_time",
          width: 200,
          scopedSlots: { customRender: "create_time" },
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        activatedIsNeed: true,
        getDataListURL: "/person/page",
        deleteURL: "/person/delete",
      },
      dataForm: {
        name: "",
        company_name: "",
        company_null: 1,
      },
      exportFileKey: personFile,
      exportFileName: "人员导出文件",
    };
  },
  methods: {
    moment,
    //批量分配分包单位
    resetCompany() {
      // const index = this.dataListSelections.findIndex(v=> !!v.company_id)
      // if(index > -1){

      // }
      this.$refs.resetCompany.init();
    },
    confirmCompany(company_id) {
      this.confirmCompanyLoading = true;
      const ids = this.dataListSelections.map((v) => v.id);
      resetCompanyId({ids: ids, company_id: company_id}).then(res=>{
        this.$message.success("批量分配成功")
        this.getDataList()
      })
    },
    //切换
    changeCompanyNull(e) {
      console.log(e);
      if (e.target.value == 2) {
        this.dataForm.name = "";
        this.dataForm.company_name = "";
      }
    },
    //批量上传
    batchUpload() {
      this.$refs.batchUploadPerson.init();
    },
    // onSelectChange(selectedRowKeys, selectedRows) {
    //   this.selectedRowKeys = selectedRowKeys;
    //   this.dataListSelections = selectedRows;
    // },
    addOrUpdateHandle_(id = "", project_id = "", isshow = "") {
      console.log(id, project_id, isshow);
      this.$router.push({
        path: "/person/autoPerson",
        query: { id: id, project_id: project_id, isshow: isshow },
      });
    },
    //退场
    exit(id, is_exit) {
      exitPerson({ id: id, is_exit: is_exit == 1 ? 0 : 1 }).then((res) => {
        this.$message.success(is_exit == 0 ? "退场成功" : "进场成功");
        this.query();
      });
    },
  },
};
</script>

<style></style>